<template>
  <ul :class="itemClass">
    <template v-for="(item, index) in sidebarItems" :key="index">
      <list-item v-if="checkPermissions(item) && showable(item)" :item="item" :index="item.name" :is-child="isChild" />
    </template>
  </ul>
</template>

<script setup>
import { computed, inject } from 'vue'

import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'

import { useAuthStore } from '@/stores/retailer/auth.js'
import Retailer from '@/utilities/retailerHelper.js'

import ListItem from '@/components/ListItem.vue'

const router = useRouter()

const props = defineProps({
  listItems: {
    type: Array,
    default: () => []
  },
  itemClass: {
    type: String
  },
  header: {
    type: Boolean,
    default: false
  },
  isChild: {
    type: Boolean,
    default: false
  },
  user: {
    type: Object
  }
})

const vueCan = inject(['VueCan'])

const authStore = useAuthStore()
const { user } = storeToRefs(authStore)

const sidebarItems = computed(() => {
  const listItemslist = props.listItems
  const firstPathSegment = window.location.pathname.split('/').filter(pathName => pathName)[0]

  if (firstPathSegment === 'admin') {
    return listItemslist
  }

  return listItemslist.filter(item => {
    const resolved = router.resolve({ name: item.name })
    const routeMeta = resolved.meta || {}

    // Hide sidebar entries the retailer's type cannot open — same question the router's global
    // guard asks, so the sidebar can never offer a link that redirects to the dashboard.
    if (Retailer.canAccessRouteMeta(routeMeta) === false) {
      return false
    }

    // Regular retailer - sales channel check
    const noSalesChannels = user.value.retailer.sales_channels?.length === 0

    if (noSalesChannels === false) {
      return true
    }

    // No sales channels - check if route is allowed without sales channels
    if (typeof routeMeta.allowWithoutSalesChannels === 'function') {
      return routeMeta.allowWithoutSalesChannels(user.value.retailer)
    }

    return false
  })
})

const checkPermissions = item => {
  if (item.permission) {
    if (item.permission === 'owner') {
      const roles = item.roles !== undefined ? item.roles : []
      return vueCan.$retailerCan(props.user, roles)
    } else {
      return vueCan.$can(item.permission)
    }
  } else if (item.child && !item.permission) {
    // Check parent item permission with child permission
    let canShowParentItem = false
    const perms = []

    item.child.forEach(childItem => {
      if (childItem.permission) {
        perms.push(childItem.permission)
      }

      if (childItem.child) {
        childItem.child.forEach(ci => {
          if (ci.permission) {
            perms.push(ci.permission)
          }
        })
      }
    })

    // if not have any child permission
    if (perms.length === 0) {
      return true
    }

    perms.forEach(perm => {
      if (vueCan.$can(perm)) {
        canShowParentItem = true
      }
    })

    return canShowParentItem
  } else {
    return true
  }
}

const showable = item => {
  if (Object.hasOwn(item, 'show')) {
    return item.show()
  }

  return true
}
</script>

